import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-';

export default {
    path: '/bcos',
    name: 'BCOS',
    redirect: {
        name: `${pre}home`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'home',
            name: `${pre}home`,
            meta: {
                ...meta,
                title: 'FISCO-BCOS',
                closable: true
            },
            component: () => import('@/bcos/views/home')
        },
        {
            path: 'privateKey',
            name: `${pre}privateKey`,
            meta: {
                ...meta,
                title: '私钥管理',
                closable: true
            },
            component: () => import('@/bcos/views/private-key')
        },
        {
            path: 'app',
            name: `${pre}app`,
            meta: {
                ...meta,
                title: '应用管理',
                closable: true
            },
            component: () => import('@/bcos/views/app')
        },
        {
            path: 'browser',
            name: `${pre}browser`,
            meta: {
                ...meta,
                title: '区块浏览器',
                closable: true
            },
            component: () => import('@/bcos/views/browser')
        },
    ]
};
